import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import React, { useEffect, useState } from 'react';
import { FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import useMobileLayout from 'Hooks/useMobileLayout';
import { currency } from 'Helpers/Formats';
import AnalyzeYourExpensesLegendItem
  from 'Views/Page/Content/Modal/Layouts/AnalyzeYourExpensesTemplate/AnalyzeYourExpensesLegendItem';

// We don't have an FD Pie Chart yet, so we are using recharts for the time being
export const AnalyzeYourExpensesChart = ({ resource, onLegendClick, onChartClick }) => {
  const [data, setData] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);

  const isMobile = useMobileLayout();

  const legendProps = isMobile ? {
    verticalAlign: 'top',
  } : {
    align: 'left',
    verticalAlign: 'middle',
  };

  function handleLegendOnClick(chartData) {
    setSelectedValue(chartData.value);
    onLegendClick(chartData);
  }

  function handleChartOnClick(_, index) {
    setSelectedValue(data[index].name);
    onChartClick(data[index]);
  }

  const aspectRatio = isMobile ? (2 / 3) : (2 / 1);

  useEffect(() => {
    const parsedData = resource?.attr('chartData').resources().list().map(chartData => ({
      type: chartData.id(),
      name: chartData.attr('label'),
      value: parseFloat(chartData.attr('value')),
      color: chartData.attr('color'),
      description: chartData.attr('description'),
    }));
    setData(parsedData);
  }, []);

  const labelFormatter = (value, entry) => {
    const { payload } = entry;
    const formattedValue = payload?.value ? `: ${currency(payload.value, true)}` : '';

    return (<span style={{ color: '#003E54' }}>{value}{formattedValue}</span>);
  };

  const renderLegend = (legendData) => {
    const { payload } = legendData;
    return (
      <FDStack direction={'column'} spacing={2}>
        {
          payload.map((entry, index) => (
            <AnalyzeYourExpensesLegendItem item={entry} selectedValue={selectedValue} index={index} onLegendClick={handleLegendOnClick} />
          ))
        }
      </FDStack>
    );
  };

  return (
    <ResponsiveContainer style={{ aspectRatio }} aspect={aspectRatio}>
      <PieChart width={200} height={300}>
        <Pie
          data={data}
          dataKey="value"
          outerRadius="100%"
          startAngle={90}
          endAngle={450}
          strokeWidth={1}
          onClick={handleChartOnClick}
        >
          {data.map((entry) => <Cell key={entry.label} fill={entry.color} />)}
        </Pie>
        <Legend
          layout="vertical"
          formatter={labelFormatter}
          iconType={'circle'}
          content={renderLegend}
          {...legendProps}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

AnalyzeYourExpensesChart.defaultProps = {
  onLegendClick: () => {},
  onChartClick: () => {},
};

AnalyzeYourExpensesChart.propTypes = {
  resource: PropTypes.object.isRequired,
  onLegendClick: PropTypes.func,
  onChartClick: PropTypes.func,
};
